/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Logic moved from theme.liquid for page transitions and cart refresh
(function () {
  window.onpageshow = function() {
    if (window.theme && window.theme.showPageTransition) {
      var pageTransition = document.querySelector(".PageTransition");

      if (pageTransition) {
        pageTransition.style.visibility = "visible";
        pageTransition.style.opacity = "0";
      }
    }

    // When the page is loaded from the cache, we have to reload the cart content
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
      bubbles: true
    }));
  };
})();

// Custom logic for fragrance finder (placeholder)
if (document.querySelector("#fragrance-finder-container")) {
  // Initialize fragrance finder app
}

// Move Clearpay/Afterpay on-site messaging below the Klarna block.
(function () {
  if (!document.body.classList.contains('template-product')) return;

  function findKlarnaAnchor() {
    var kp = document.querySelector('klarna-placement');
    if (kp) return kp.closest('.Product__AppBlock') || kp;
    var blocks = document.querySelectorAll('.Product__AppBlock');
    if (blocks.length) return blocks[blocks.length - 1];
    return null;
  }

  function findClearpay() {
    // The Clearpay app renders a <square-placement> custom element
    return document.querySelector('square-placement') ||
           document.querySelector('[id*="clearpay_on_site_messaging"]');
  }

  function moveClearpay() {
    var clearpay = findClearpay();
    var klarnaAnchor = findKlarnaAnchor();
    if (!clearpay || !klarnaAnchor) return;
    // Already in position — no DOM change needed (avoids mutation loop)
    if (clearpay.previousElementSibling === klarnaAnchor) return;
    klarnaAnchor.parentNode.insertBefore(clearpay, klarnaAnchor.nextSibling);
  }

  // Keep watching — Clearpay's script may re-inject after our initial move
  var observer = new MutationObserver(moveClearpay);
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { observer.disconnect(); }, 10000);

  moveClearpay();
})();

// Centre-align the Clearpay widget (shadow DOM requires JS injection)
(function () {
  var CSS = ':host { text-align: center !important; } .afterpay-paragraph { text-align: center !important; }';

  function injectStyle(shadowRoot) {
    if (shadowRoot.querySelector('#cp-center')) return;
    var s = document.createElement('style');
    s.id = 'cp-center';
    s.textContent = CSS;
    shadowRoot.appendChild(s);
  }

  function styleClearpay() {
    var el = document.querySelector('square-placement');
    if (!el || !el.shadowRoot) return false;
    injectStyle(el.shadowRoot);
    // Re-inject if Clearpay re-renders its shadow root
    new MutationObserver(function () {
      injectStyle(el.shadowRoot);
    }).observe(el.shadowRoot, { childList: true });
    return true;
  }

  if (!styleClearpay()) {
    var observer = new MutationObserver(function () {
      if (styleClearpay()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 10000);
  }
})();